export const configsDefaults = () => {
    return {
        sentence_start_format: "CODE",
        phrases_h: "",
        phrases_p: "",
        measures: [
            [6, 6],
            [6, 6],
            [6, 6],
            [6, 6],
        ],
    };
};
export default {
    availableFormats: [
        { value: "CODE", title: "Código" },
        { value: "ASTERISK", title: "Asterisco" },
        { value: "NOT_SPACE", title: "Sin separador" },
        { value: "ENTER", title: "Salto de linea" },
        { value: "GUION", title: "Guión -" },
    ],
    measuresLabels: [
        {
            id: 1,
            title: "ET Pequeña",
            subtitle: "Aprox 5x6cm - 5x7cm | Baker 7x5cm",
            type: 'E'
        },
        {
            id: 2,
            title: "ET Mediana",
            subtitle: "Aprox 7x10cm - 7x12cm",
            type: 'F'
        },
        {
            id: 3,
            title: "ET Grande",
            subtitle: "Aprox 18x12cm",
            type: 'G'
        },
        {
            id: 4,
            title: "ET Extra-Grande",
            subtitle: "Aprox 22x18cm | Baker 29x21cm",
            type: 'H'
        },
    ],
    productLabelConfigs: configsDefaults(),
};
